<template>
  <div id="app">
    <template v-if="show">
      <el-container>
        <el-header height="56px">
          <header-page></header-page>
        </el-header>
        <el-container>
          <el-aside width="200px">
            <left-menu :list="menuList" :active="active"></left-menu>
          </el-aside>
          <el-container>
            <el-main>
                <header-breadcrumb :list="breadcrumbList"></header-breadcrumb>
                <router-view />
            </el-main>
          </el-container>
        </el-container>
      </el-container>
    </template>
    <template v-else>
        <router-view />
    </template>
   
  </div>
</template>

<script>
import headerPage from '@/components/header'
import leftMenu from '@/components/left-menu'
import headerBreadcrumb from "@/components/header-breadcrumb"
import {checkPermissions} from '@/utils'
import {routes} from '@/router/router.config'

export default {
  name: 'App',
  components:{
    'header-page':headerPage,
    'left-menu':leftMenu,
    'header-breadcrumb':headerBreadcrumb
  },
  data(){
    return {
      menuList:[],
      breadcrumbList:[],
      active:'',
      show:false,
    }
  },
  watch:{
    '$route':{
      handler(to){
        this.show = to.path !== '/login'
        if(to.path !== 'login'){
          this.breadcrumbList = to.matched
          this.active = to.name
        }
      },
      deep:true
    }
  },
  created(){
    this.getMenuList()
  },
  methods:{
    getMenuList(){
      this.menuList = routes.filter((item)=>{
        if(item.path == '/system'){
            item.children.forEach(row=>{
              if(row.path == 'user'){
                 row.meta.show = checkPermissions('/system/user')
              }
            })
        }
        return item.meta.show
      })
    }
  }
}
</script>

<style>
html,body{
  margin: 0;
  padding: 0;
}
#app{
 height: 100vh;
}
.el-header{
  padding:0 !important;
}
.el-container{
  background-color: #E4E7EA;
}
.el-card__body, .el-main{
  padding: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue